import axios from "axios";
import { RecordsListItem } from "fe-shared/src/types/common";
import { InventoryAdjustmentDetails } from "../../../types/inventoryAdjustments";
import { EditInventoryAdjustmentParams } from "./types";

interface InvalidateParams {
  overallAdjustmentId: number;
  invalidationReason: string;
  isShowToParticipant: boolean;
}

interface ApproveParams {
  overallAdjustmentId: number;
  comment: string;
}

interface AddNoteParams {
  text: string;
  overallAdjustmentId: number;
}
export const getInventoryAdjustment = (
  queryKey: string,
  overallAdjustmentNumber: string
) =>
  axios
    .get<InventoryAdjustmentDetails>("overallAdjustment", {
      params: { overallAdjustmentNumber },
    })
    .then(({ data }) => data);

export const addInventoryAdjustmentNote = ({
  text,
  overallAdjustmentId,
}: AddNoteParams) =>
  axios
    .post(
      "overallAdjustment/notes",
      { text },
      { params: { overallAdjustmentId }, hideToast: true }
    )
    .then((res) => res.data);

export const getInventoryAdjustmentNotes = (
  overallAdjustmentId: number
): Promise<RecordsListItem[]> =>
  axios
    .get("overallAdjustment/notes", {
      params: { overallAdjustmentId },
    })
    .then((res) => res.data);

export const invalidate = ({
  overallAdjustmentId,
  invalidationReason,
  isShowToParticipant,
}: InvalidateParams): Promise<any> =>
  axios
    .post("overallAdjustment/invalidate", {
      overallAdjustmentId,
      invalidationInfo: {
        reason: invalidationReason,
        showToParticipant: isShowToParticipant,
      },
    })
    .then((res) => res.data);

export const approve = ({
  overallAdjustmentId,
  comment,
}: ApproveParams): Promise<any> =>
  axios
    .post("overallAdjustment/approve", { overallAdjustmentId, comment })
    .then((res) => res.data);

export const editInventoryAdjustment = (
  params: EditInventoryAdjustmentParams
) => axios.put("overallAdjustment", params).then(({ data }) => data);

export default {
  approve,
  invalidate,
  getInventoryAdjustment,
  editInventoryAdjustment,
  addInventoryAdjustmentNote,
  getInventoryAdjustmentNotes,
};
